export class AuthenticationFailedError extends Error {
  constructor(message: string = "Authentication failed") {
    super(message);
    this.name = "AuthenticationFailedError";
  }
}

export function isAuthenticationError(error: unknown): error is AuthenticationFailedError {
  return error instanceof AuthenticationFailedError;
}

export function isNetworkError(error: unknown): boolean {
  if (error instanceof Error) {
    const message = error.message.toLowerCase();
    return (
      message.includes('network') ||
      message.includes('connection') ||
      message.includes('timeout') ||
      message.includes('cors')
    );
  }
  
  return false;
}
